<template>
  <div class="logo" @click="pushHome">
    <img class="logo_img" width="28" height="20" src="../assets/xueshiyun_logo.png" alt="">
    <i class="iconfont iconxueshiyun text_color_active"></i>
  </div>
</template>
<script>
import { getHomePage } from '~/utils/assist'
export default {
  name: 'xsy_logo_txt',
  methods: {
    pushHome () {
      location.href = getHomePage()
    }
  }
}
</script>
<style lang="scss" scoped>
  .logo {
    display: flex;
    align-items: center;
    margin-left: 40px;
    cursor: pointer;
    &_img {
      width: 28px;
      height: 20px;
      margin-right: 20px;
    }
    &_txt {
      width: 62px;
      height: 20px;
    }
    & > i {
      font-size: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/xsy-logo.vue